import { useState, useEffect, useCallback } from "react";

export const useAssets = ({ authToken, setToast }) => {
  const [assets, setAssets] = useState([]);
  const [isUploadingAsset, setIsUploadingAsset] = useState(false);

  const fetchAssets = useCallback(async () => {
    if (!authToken) return;
    try {
      const res = await fetch("/api/assets", {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      if (res.ok) {
        const data = await res.json();
        setAssets(data.assets || []);
      }
    } catch (err) {
      console.error("Failed to fetch assets:", err);
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken) {
      fetchAssets();
    }
  }, [authToken, fetchAssets]);

  const uploadAsset = async (file, assetType = "certificate") => {
    if (!authToken) return;
    setIsUploadingAsset(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("asset_type", assetType);
      const res = await fetch("/api/assets/upload", {
        method: "POST",
        headers: { Authorization: `Bearer ${authToken}` },
        body: formData,
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        if (setToast) setToast({ message: "Asset uploaded successfully!", type: "success" });
        fetchAssets();
        return data.asset;
      } else {
        alert(`Upload failed: ${data.error || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Asset upload error:", err);
      alert("Network error during asset upload.");
    } finally {
      setIsUploadingAsset(false);
    }
  };

  const deleteAsset = async (assetId) => {
    if (!authToken) return;
    try {
      const res = await fetch(`/api/assets/${assetId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${authToken}` },
      });
      if (res.ok) {
        if (setToast) setToast({ message: "Asset deleted.", type: "success" });
        fetchAssets();
      } else {
        const data = await res.json();
        alert(`Delete failed: ${data.error || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Delete asset error:", err);
    }
  };

  return {
    assets,
    setAssets,
    isUploadingAsset,
    fetchAssets,
    uploadAsset,
    deleteAsset,
  };
};
